// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1qKG7","search":"Settings_search__3kAYJ","filter":"Settings_filter__13QWA"};